import React from 'react';
import './ComingSoon.css'; // For styles

const ComingSoon = ({ moduleName }) => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-box">
        {/* <h2 className="coming-soon-header">{moduleName}</h2> */}
        <p className="coming-soon-subheader">Coming Soon!</p>
        <div className="coming-soon-animation">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
        <p className="coming-soon-message">Stay tuned...</p>
      </div>
    </div>
  );
};

export default ComingSoon;
